import { Popover } from "antd";
import React, { FC } from "react";
import Card from "./card";
import { Location } from "../../queries/auto-generated/schemas";
import logo from "../../logo.svg";

export const MarkerCard: FC<{ lat: number; lng: number; location: Location }> =
  ({ location }) => (
    <Popover
      content={<Card location={location} />}
      trigger={["hover", "click", "focus"]}
    >
      <div style={{ cursor: "pointer" }}>
        <img
          style={{ width: "50px" }}
          src={logo}
          alt={location?.name ?? "Jay Bird's location"}
        />
      </div>
    </Popover>
  );
